import React from 'react';
import AKSearchIcon from '@atlaskit/icon/core/migration/search';
import { N800 } from '@atlaskit/theme/colors';
export var SearchIcon = function SearchIcon(_ref) {
  var isExpanded = _ref.isExpanded,
    theme = _ref.theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$primaryColor = _ref.primaryColor,
    primaryColor = _ref$primaryColor === void 0 ? "var(--ds-text, ".concat(N800, ")") : _ref$primaryColor,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label;
  return /*#__PURE__*/React.createElement(AKSearchIcon, {
    label: label,
    LEGACY_primaryColor: isExpanded ? primaryColor : theme.default.color,
    LEGACY_size: size
    // NOTE: color do not accept string type but here primaryColor is string, so need to use any
    ,
    color: isExpanded ? primaryColor : theme.default.color
  });
};